"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _selfie_segmentation = require("@mediapipe/selfie_segmentation");
var _camera_utils = require("@mediapipe/camera_utils");
var _utils = require("../utils");
var _axios = _interopRequireDefault(require("axios"));
var _qrcode = require("qrcode.react");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var PhotoCell = function PhotoCell(_ref5) {
  var cell = _ref5.cell,
    page = _ref5.page,
    _ref5$uriTransformer = _ref5.uriTransformer,
    uriTransformer = _ref5$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref5$uriTransformer,
    intl = _ref5.intl,
    defaultLanguage = _ref5.defaultLanguage,
    project = _ref5.project,
    logEvent = _ref5.logEvent;
  var videoRef = (0, _react.useRef)(null); // Référence pour l'élément vidéo
  var canvasRef = (0, _react.useRef)(null); // Référence pour le canvas
  var segmentationMaskRef = (0, _react.useRef)(null); // Masque de segmentation actuel
  var _ref6 = (0, _react.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    photo = _ref7[0],
    setPhoto = _ref7[1]; // État pour stocker la photo capturée
  var _ref8 = (0, _react.useState)(3),
    _ref9 = _slicedToArray(_ref8, 2),
    timer = _ref9[0],
    setTimer = _ref9[1]; // État pour stocker le temps restant
  var _ref0 = (0, _react.useState)(false),
    _ref1 = _slicedToArray(_ref0, 2),
    start = _ref1[0],
    setStart = _ref1[1]; // État pour démarrer le compte à rebours
  var _ref10 = (0, _react.useState)(''),
    _ref11 = _slicedToArray(_ref10, 2),
    email = _ref11[0],
    setEmail = _ref11[1]; // État pour stocker l'email
  var _ref12 = (0, _react.useState)(null),
    _ref13 = _slicedToArray(_ref12, 2),
    response = _ref13[0],
    setResponse = _ref13[1]; // État pour stocker la réponse
  var _ref14 = (0, _react.useState)(''),
    _ref15 = _slicedToArray(_ref14, 2),
    error = _ref15[0],
    setError = _ref15[1]; // État pour stocker l'erreur
  var _ref16 = (0, _react.useState)(false),
    _ref17 = _slicedToArray(_ref16, 2),
    photoSended = _ref17[0],
    setPhotoSended = _ref17[1]; // État pour envoyer la photo

  (0, _react.useEffect)(function () {
    var selfieSegmentation = new _selfie_segmentation.SelfieSegmentation({
      locateFile: function locateFile(file) {
        return "https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/".concat(file);
      }
    });
    selfieSegmentation.setOptions({
      modelSelection: 0,
      // 0 = modèle général (précis), 1 = modèle léger (rapide)
      selfieMode: false // false = meilleure précision pour les portraits
    });

    // Initialiser le modèle pour une meilleure qualité
    selfieSegmentation.initialize().catch(function (err) {
      console.error("Erreur lors de l'initialisation de SelfieSegmentation:", err);
    });
    var onResults = function onResults(results) {
      if (results.segmentationMask && canvasRef.current && videoRef.current) {
        var video = videoRef.current;
        var videoWidth = video.videoWidth;
        var videoHeight = video.videoHeight;
        if (!videoWidth || !videoHeight) return;

        // Calculer les dimensions du canvas en préservant le ratio d'aspect de la vidéo
        var container = canvasRef.current.parentElement;
        if (container) {
          var containerWidth = container.clientWidth;
          var containerHeight = container.clientHeight;
          var videoRatio = videoWidth / videoHeight;
          var containerRatio = containerWidth / containerHeight;

          // Calculer les dimensions du canvas pour qu'il s'adapte au conteneur
          // tout en préservant le ratio de la vidéo
          var canvasWidth, canvasHeight;
          if (videoRatio > containerRatio) {
            // La vidéo est plus large, on ajuste selon la largeur
            canvasWidth = containerWidth;
            canvasHeight = canvasWidth / videoRatio;
          } else {
            // La vidéo est plus haute, on ajuste selon la hauteur
            canvasHeight = containerHeight;
            canvasWidth = canvasHeight * videoRatio;
          }

          // Utiliser devicePixelRatio pour les écrans haute résolution
          var dpr = window.devicePixelRatio || 1;
          canvasRef.current.width = canvasWidth * dpr;
          canvasRef.current.height = canvasHeight * dpr;
        } else {
          // Fallback : utiliser les dimensions exactes de la vidéo
          canvasRef.current.width = videoWidth;
          canvasRef.current.height = videoHeight;
        }
        var context = canvasRef.current.getContext('2d');
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';

        // Récupérer la vidéo en arrière-plan
        context.save();
        context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

        // Dessiner l'image de la vidéo en préservant le ratio exact
        // Utiliser les dimensions complètes de la vidéo source
        context.drawImage(video, 0, 0, videoWidth, videoHeight, 0, 0, canvasRef.current.width, canvasRef.current.height);
        context.globalCompositeOperation = 'destination-in';
        // Dessiner le masque aux mêmes dimensions que le canvas
        context.drawImage(results.segmentationMask, 0, 0, canvasRef.current.width, canvasRef.current.height);
        context.restore();

        // Stocker le masque de segmentation pour la capture haute résolution
        if (results.segmentationMask) {
          segmentationMaskRef.current = results.segmentationMask;
        }
      }
    };
    selfieSegmentation.onResults(onResults);
    if (videoRef.current) {
      var camera = new _camera_utils.Camera(videoRef.current, {
        onFrame: function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var _t2;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  _context.p = 0;
                  if (!(videoRef.current && videoRef.current.readyState >= 2)) {
                    _context.n = 1;
                    break;
                  }
                  _context.n = 1;
                  return selfieSegmentation.send({
                    image: videoRef.current
                  });
                case 1:
                  _context.n = 3;
                  break;
                case 2:
                  _context.p = 2;
                  _t2 = _context.v;
                  console.error("Error sending frame to Mediapipe:", _t2);
                  // Ne pas spammer les erreurs si c'est juste une frame qui a échoué
                case 3:
                  return _context.a(2);
              }
            }, _callee, null, [[0, 2]]);
          }));
          return function onFrame() {
            return _ref.apply(this, arguments);
          };
        }(),
        width: 2160,
        // Résolution pour meilleure qualité
        height: 3840 // Ratio portrait 9:16 maintenu
      });
      if (camera) {
        camera.start();
      }
    } else {
      console.error("videoRef.current is not available.");
    }
    return function () {
      if (canvasRef.current) {
        //canvasRef.current.stop();
      }
    };
  }, []);
  var sendEmail = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
      var _response, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            e.preventDefault();
            setPhotoSended(true);
            _context2.p = 1;
            _context2.n = 2;
            return _axios.default.post("".concat(project.backEndUri, "/send_photo"), {
              email: email,
              cell_id: cell.id,
              image: photo,
              additional_data: {
                email: email
              }
            });
          case 2:
            _response = _context2.v;
            setResponse(_response.data);
            setError('La photo a été envoyée avec succès');
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t3 = _context2.v;
            console.error("Error:", _t3);
            setPhotoSended(false);
            setError('Erreur lors de l\'envoi de l\'email');
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function sendEmail(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var sendPhoto = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _response2, _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!(!photo || photo === 1)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            _context3.p = 1;
            _context3.n = 2;
            return _axios.default.post("".concat(project.backEndUri, "/send_photo"), {
              email: email,
              cell_id: cell.id,
              image: photo,
              additional_data: {
                val: 'none'
              }
            });
          case 2:
            _response2 = _context3.v;
            setResponse(_response2.data);
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t4 = _context3.v;
            console.error("Error:", _t4);
            setError('Erreur lors de l\'enregistrement de la photo');
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function sendPhoto() {
      return _ref3.apply(this, arguments);
    };
  }();
  var dismissKeyboard = function dismissKeyboard() {
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };
  (0, _react.useEffect)(function () {
    sendPhoto();
  }, [photo]);
  var captureImage = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var video, videoWidth, videoHeight, maxPixels, videoPixels, targetWidth, targetHeight, scale, captureCanvas, captureContext, maskWidth, maskHeight, maskCanvas, maskContext, blurCanvas, blurContext, backgroundImage;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            video = videoRef.current;
            videoWidth = video.videoWidth;
            videoHeight = video.videoHeight; // Utiliser la résolution native de la vidéo pour préserver le ratio d'aspect exact
            // Limiter à 4K pour éviter les problèmes de mémoire, mais en préservant le ratio
            maxPixels = 3840 * 2160; // Limite de pixels pour 4K
            videoPixels = videoWidth * videoHeight;
            targetWidth = videoWidth;
            targetHeight = videoHeight; // Si la vidéo dépasse la limite, redimensionner en préservant le ratio
            if (videoPixels > maxPixels) {
              scale = Math.sqrt(maxPixels / videoPixels);
              targetWidth = Math.round(videoWidth * scale);
              targetHeight = Math.round(videoHeight * scale);
            }

            // Créer un canvas temporaire de haute résolution pour la capture
            // Utiliser exactement les dimensions calculées pour préserver le ratio
            captureCanvas = document.createElement('canvas');
            captureCanvas.width = targetWidth;
            captureCanvas.height = targetHeight;
            captureContext = captureCanvas.getContext('2d'); // Améliorer la qualité de rendu
            captureContext.imageSmoothingEnabled = true;
            captureContext.imageSmoothingQuality = 'high';

            // Attendre une frame fraîche de la vidéo pour une meilleure qualité
            _context4.n = 1;
            return new Promise(function (resolve) {
              if (video.requestVideoFrameCallback) {
                video.requestVideoFrameCallback(function () {
                  return resolve();
                });
              } else {
                // Fallback pour les navigateurs qui ne supportent pas requestVideoFrameCallback
                setTimeout(resolve, 100);
              }
            });
          case 1:
            // Capturer la frame vidéo avec inversion horizontale
            // IMPORTANT : Utiliser exactement les dimensions de la vidéo pour éviter tout étirement
            // Le canvas a déjà les bonnes dimensions (targetWidth x targetHeight) qui préservent le ratio
            captureContext.save();
            captureContext.scale(-1, 1);
            captureContext.translate(-targetWidth, 0);
            // Dessiner la vidéo en utilisant ses dimensions natives exactes
            // Le redimensionnement vers targetWidth/targetHeight préserve le ratio car calculé proportionnellement
            captureContext.drawImage(video, 0, 0, videoWidth, videoHeight,
            // Source : dimensions natives de la vidéo
            0, 0, targetWidth, targetHeight // Destination : dimensions calculées qui préservent le ratio
            );
            captureContext.restore();

            // Appliquer le masque de segmentation si disponible
            if (segmentationMaskRef.current) {
              // Obtenir les dimensions du masque original
              maskWidth = segmentationMaskRef.current.width || segmentationMaskRef.current.videoWidth || targetWidth;
              maskHeight = segmentationMaskRef.current.height || segmentationMaskRef.current.videoHeight || targetHeight; // Créer un canvas temporaire pour le masque à la bonne résolution
              maskCanvas = document.createElement('canvas');
              maskCanvas.width = targetWidth;
              maskCanvas.height = targetHeight;
              maskContext = maskCanvas.getContext('2d');
              maskContext.imageSmoothingEnabled = true;
              maskContext.imageSmoothingQuality = 'high';

              // Dessiner le masque en préservant son ratio d'aspect original
              // Utiliser les dimensions natives du masque pour éviter l'étirement
              maskContext.drawImage(segmentationMaskRef.current, 0, 0, maskWidth, maskHeight,
              // Source : dimensions natives du masque
              0, 0, targetWidth, targetHeight // Destination : dimensions cibles (qui préservent le ratio de la vidéo)
              );

              // Post-traitement du masque pour améliorer les bords (anti-aliasing)
              // Créer un canvas temporaire pour le flou
              blurCanvas = document.createElement('canvas');
              blurCanvas.width = targetWidth;
              blurCanvas.height = targetHeight;
              blurContext = blurCanvas.getContext('2d');
              blurContext.imageSmoothingEnabled = true;
              blurContext.imageSmoothingQuality = 'high';

              // Appliquer un léger flou pour adoucir les bords
              blurContext.filter = 'blur(0.5px)';
              blurContext.drawImage(maskCanvas, 0, 0);
              blurContext.filter = 'none';

              // Mélanger le masque original avec la version floutée pour des bords plus doux
              maskContext.globalCompositeOperation = 'source-over';
              maskContext.globalAlpha = 0.8; // 80% du masque original pour préserver la netteté
              maskContext.drawImage(maskCanvas, 0, 0);
              maskContext.globalAlpha = 0.2; // 20% de la version floutée pour adoucir les bords
              maskContext.drawImage(blurCanvas, 0, 0);
              maskContext.globalAlpha = 1.0;
              maskContext.globalCompositeOperation = 'source-over';

              // Appliquer le masque amélioré à l'image capturée
              captureContext.globalCompositeOperation = 'destination-in';
              captureContext.drawImage(maskCanvas, 0, 0);
              captureContext.globalCompositeOperation = 'source-over';
            }

            // Charger et dessiner l'image de fond
            backgroundImage = new Image();
            backgroundImage.crossOrigin = "anonymous";
            backgroundImage.src = uriTransformer(cell.frame_uri);
            return _context4.a(2, new Promise(function (resolve, reject) {
              backgroundImage.onload = function () {
                try {
                  // Dessiner le fond avec haute qualité en préservant son ratio d'aspect
                  captureContext.imageSmoothingEnabled = true;
                  captureContext.imageSmoothingQuality = 'high';

                  // Calculer les dimensions du fond pour qu'il remplisse le canvas sans déformation
                  var bgRatio = backgroundImage.width / backgroundImage.height;
                  var canvasRatio = targetWidth / targetHeight;
                  var bgWidth, bgHeight, bgX, bgY;
                  if (bgRatio > canvasRatio) {
                    // Le fond est plus large, on ajuste la hauteur
                    bgHeight = targetHeight;
                    bgWidth = bgHeight * bgRatio;
                    bgX = (targetWidth - bgWidth) / 2;
                    bgY = 0;
                  } else {
                    // Le fond est plus haut, on ajuste la largeur
                    bgWidth = targetWidth;
                    bgHeight = bgWidth / bgRatio;
                    bgX = 0;
                    bgY = (targetHeight - bgHeight) / 2;
                  }

                  // Dessiner le fond en préservant son ratio
                  captureContext.drawImage(backgroundImage, bgX, bgY, bgWidth, bgHeight);

                  // Exporter en PNG pour une qualité maximale (sans perte)
                  // Si la taille est trop importante, on peut utiliser JPEG avec qualité maximale
                  var imageUrl;
                  if (targetWidth * targetHeight > 8 * 1024 * 1024) {
                    // Si > 8MP, utiliser JPEG haute qualité
                    imageUrl = captureCanvas.toDataURL('image/jpeg', 0.98);
                  } else {
                    imageUrl = captureCanvas.toDataURL('image/png');
                  }
                  setPhoto(imageUrl);
                  resolve(imageUrl);
                } catch (error) {
                  console.error("Erreur lors du dessin de l'image avec le fond transparent :", error);
                  reject(error);
                }
              };
              backgroundImage.onerror = function (err) {
                console.error("Erreur lors du chargement de l'image avec le fond transparent :", err);
                reject(err);
              };
            }));
        }
      }, _callee4);
    }));
    return function captureImage() {
      return _ref4.apply(this, arguments);
    };
  }();

  // Fonction pour capturer une photo
  var takePhoto = function takePhoto() {
    if (start) {
      return;
    }
    setStart(true); // Démarrer le compte à rebours
    var interval = setInterval(function () {
      setTimer(function (prevTimer) {
        var newTimer = prevTimer - 1;
        if (newTimer === 0) {
          setPhoto(1);
          clearInterval(interval); // Arrêter le compte à rebours
          captureImage().then(function () {
            // La photo sera envoyée automatiquement via useEffect
          }).catch(function (error) {
            console.error("Erreur lors de la capture:", error);
            setError('Erreur lors de la capture de la photo');
            setPhoto(null);
            setStart(false);
            setTimer(3);
          });
        }
        return newTimer;
      });
    }, 1000);
  };
  if (photo) {
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: dismissKeyboard,
      style: {
        position: 'fixed',
        zIndex: '5000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        fontFamily: project ? project.default_button_font : 'Arial'
      }
    }, photo !== 1 ? /*#__PURE__*/_react.default.createElement("img", {
      src: photo,
      style: {
        borderRadius: '1em',
        left: '5%',
        top: '5%',
        position: 'fixed',
        width: '90%',
        height: '90%',
        objectFit: 'cover',
        zIndex: 1000,
        filter: 'blur(20px)'
      }
    }) : /*#__PURE__*/_react.default.createElement(Loading, null), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        // Superposition noire avec opacité
        zIndex: 1100 // S'assurer que cela soit au-dessus de l'image capturée
      }
    }, photo !== 1 ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        left: '25%',
        top: '8%',
        height: '50%',
        width: '50%',
        background: "url(".concat(photo, ")"),
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    }) : /*#__PURE__*/_react.default.createElement(Loading, null), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        bottom: '15%',
        left: '20%',
        width: '60%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
        padding: '1em',
        borderRadius: '1em',
        boxShadow: '1.2em 1.2em 1.2em rgba(0, 0, 0, 0)'
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        textAlign: 'center',
        color: 'white',
        fontSize: '0.8em'
      }
    }, "Recevoir ma photo par email ou scanner le QR code"), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: sendEmail
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement("input", {
      required: true,
      value: email,
      onChange: function onChange(e) {
        return setEmail(e.target.value);
      },
      placeholder: "Entrez votre email",
      style: {
        background: 'rgba(255, 255, 255, 0.7)',
        color: 'black',
        border: 'none',
        padding: '0.1em',
        borderRadius: '0.8em',
        width: '100%',
        margin: 'auto',
        display: 'block',
        bottom: 0,
        outline: 'none',
        flex: 4,
        fontSize: '1em'
      },
      type: "email"
    }), response ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1,
        padding: '0.5em'
      }
    }, /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
      style: {
        margin: 'auto'
      },
      fillOpacity: 0.8,
      color: "black",
      width: '100%',
      height: '100%',
      value: "https://app.mytreeosk.com/photo/".concat(response.id)
    })) : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1,
        padding: '1em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Loading, {
      style: {
        height: '11.25%'
      }
    })))), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      disabled: photoSended,
      style: {
        background: 'rgba(255, 255, 255, 0.7)',
        color: 'black',
        border: 'none',
        padding: '0.5em',
        borderRadius: '2em',
        width: '40%',
        fontSize: '1em',
        fontWeight: 'bolder',
        outline: 'none',
        boxShadow: '1.2em 1.2em 1.2em rgba(0, 0, 0, 0.4)'
      }
    }, "Envoyer"), error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: 'red'
      }
    }, error))), /*#__PURE__*/_react.default.createElement("br", null))));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 0,
      fontFamily: project ? project.default_button_font : 'Arial'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'fixed',
      width: '70%',
      height: '70%',
      left: '15%',
      zIndex: 1000,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement("canvas", {
    ref: canvasRef,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      // 'contain' préserve le ratio d'aspect, évite l'étirement
      transformOrigin: 'center',
      transform: 'scaleX(-1)'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    onClick: takePhoto,
    style: {
      width: '50%',
      textAlign: 'center',
      position: 'fixed',
      bottom: '10%',
      left: '25%',
      zIndex: 4000
    }
  }, start && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '3em',
      color: 'white',
      margin: 'auto',
      position: 'fixed',
      top: '50%',
      left: '40%',
      width: '20%',
      height: '11.25%',
      zIndex: 5000
    }
  }, timer), /*#__PURE__*/_react.default.createElement("img", {
    width: '100%',
    style: {
      margin: 'auto'
    },
    src: uriTransformer((0, _utils.i18nData)(cell, 'btn_uri', intl, defaultLanguage))
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '70%',
      width: '70%',
      left: '15%',
      position: 'fixed',
      background: "url(".concat(uriTransformer(cell.frame_uri), ")"),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      zIndex: 2000
    }
  }), /*#__PURE__*/_react.default.createElement("video", {
    ref: videoRef,
    style: {
      display: 'none'
    }
  }));
};
function Loading(_ref18) {
  var style = _ref18.style;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n         @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(-360deg); }\n            }"
    }
  }), /*#__PURE__*/_react.default.createElement("svg", {
    style: _objectSpread({
      width: '100%',
      height: '100%'
    }, style),
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000",
    height: "1000",
    viewBox: "0 0 1000 1000",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M302 421.168C302 410.122 310.954 401.168 322 401.168H384.484C392.614 401.168 399.935 396.247 403.004 388.719L419.015 349.449C422.084 341.921 429.405 337 437.535 337H562.188C570.469 337 577.893 342.103 580.86 349.835L595.633 388.333C598.6 396.065 606.025 401.168 614.306 401.168H677C688.046 401.168 697 410.122 697 421.168V644C697 655.046 688.046 664 677 664H322C310.954 664 302 655.046 302 644V421.168Z",
    stroke: "white",
    strokeWidth: "32"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#paint0_angular_406_4_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "matrix(0 0.097 -0.097 0 500 500)"
  }, /*#__PURE__*/_react.default.createElement("foreignObject", {
    x: "-1010.31",
    y: "-1010.31",
    width: "2020.62",
    height: "2020.62"
  }, /*#__PURE__*/_react.default.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg, rgba(255, 255, 255, 1) 0deg, rgba(255, 255, 255, 0) 360deg)",
      height: "100%",
      width: "100%",
      animation: 'spin 3s infinite linear',
      transformOrigin: 'center',
      opacity: 1
    }
  })))), /*#__PURE__*/_react.default.createElement("path", {
    d: "M597 500C597 553.572 553.572 597 500 597C446.428 597 403 553.572 403 500C403 446.428 446.428 403 500 403C553.572 403 597 446.428 597 500ZM435.723 500C435.723 535.499 464.501 564.277 500 564.277C535.499 564.277 564.277 535.499 564.277 500C564.277 464.501 535.499 435.723 500 435.723C464.501 435.723 435.723 464.501 435.723 500Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":1.1879074655364585e-14,\"m01\":-194.0,\"m02\":597.0,\"m10\":194.0,\"m11\":1.1879074655364585e-14,\"m12\":403.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "paint0_angular_406_4_clip_path"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M597 500C597 553.572 553.572 597 500 597C446.428 597 403 553.572 403 500C403 446.428 446.428 403 500 403C553.572 403 597 446.428 597 500ZM435.723 500C435.723 535.499 464.501 564.277 500 564.277C535.499 564.277 564.277 535.499 564.277 500C564.277 464.501 535.499 435.723 500 435.723C464.501 435.723 435.723 464.501 435.723 500Z"
  })))));
}
var _default = exports.default = PhotoCell;